var RepairAppointment = {
    init: function(){
        const serviceOptions = document.querySelectorAll('.js-select-calendly');

        serviceOptions.forEach((item) => {
            item.addEventListener('change', (event) => {
                const isStandalone = event.currentTarget.options[event.currentTarget.selectedIndex].getAttribute('data-standalone') === 'true' ? true : false;
                if(isStandalone){
                    const standaloneURL = event.currentTarget.getAttribute('data-standalone-url');
                    window.location.href = standaloneURL;
                } else {    
                    const calendlyURL = event.currentTarget.getAttribute('data-calendly-url');
                    this.openCalendly(calendlyURL);
                }
            });
        });
    },
    openCalendly(URL){
        Calendly.initPopupWidget({url: URL});
    }
}